import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  flex: {
    display: 'flex',
  },
})

export default useStyles
